module.exports = __webpack_public_path__ + "static/media/FCAC.f5dad857.pdf";